module.exports = __webpack_public_path__ + "img/case_banner1.2556ccd5.png";